import { api } from './api'

export interface SchoolVerificationStatus {
  status: string
  documents: Array<{ url: string; type: string }>
  verificationMeta?: Record<string, string>
  createdBySource?: string
  schoolName?: string
}

export const schoolVerificationService = {
  async getStatus(schoolId: string): Promise<SchoolVerificationStatus> {
    const res = await api.get(`/schools/${schoolId}/verification-status`)
    return res.data.data
  },

  async submitDocuments(
    schoolId: string,
    documents: File[],
    meta?: Record<string, string>,
    documentTypes?: string[]
  ): Promise<{ success: boolean; message: string }> {
    const formData = new FormData()
    documents.forEach((doc) => formData.append('documents', doc))

    if (meta && Object.keys(meta).length > 0) {
      formData.append('verificationMeta', JSON.stringify(meta))
    }

    const types =
      documentTypes && documentTypes.length === documents.length
        ? documentTypes
        : documents.map(() => 'additional')
    formData.append('documentTypes', JSON.stringify(types))

    const res = await api.post(`/schools/${schoolId}/verification-documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    })
    return res.data
  },

  async updateVerificationMeta(
    schoolId: string,
    meta: Record<string, string>
  ): Promise<{ success: boolean; message?: string }> {
    const res = await api.put(`/schools/${schoolId}`, { verificationMeta: meta })
    return res.data
  },
}
